import {BankCodeType, FinancialInvestmentCompanyCodeType} from '@web/core/constants'
import makeSlice from '@web/slices/account/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'
import {BankEasyPayView} from '../../apis/response/interface/payMethod/bankEasyPay'

/**
 * 기본결제수단의 충전결제 계좌를 선택합니다.
 * - 디폴트 계좌가 점검중이라면, 점검중 아닌 계좌로 노출
 * https://oss.fin.navercorp.com/payOrder/order-qa/issues/2377#issuecomment-365589
 */
function getSelectedRechargeAccount(accounts: BankEasyPayView[]): BankEasyPayView | undefined {
    const result = accounts[0]
    if (result && !result.payable) {
        const account = accounts.find(({payable}) => payable)
        if (account) {
            return account
        }
    }
    return result
}

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {payMethod, naverpayPoint} = payload.data
            state.maintenanceInfo = payMethod.bankEasyPayServiceMaintenanceSchedule
            state.naverBankbookBenefitOnRecentPayment = naverpayPoint?.naverBankbookBenefitOnRecentPayment ?? false

            state.recharge.accounts = payMethod.recentChargedAccountFirstBankEasyPays.map((bankEasyPay) => {
                return {
                    accountKey: bankEasyPay.accountKey,
                    associatedCheckCard: bankEasyPay.associatedCheckCard,
                    bankCode: bankEasyPay.bankCode as BankCodeType | FinancialInvestmentCompanyCodeType,
                    bankName: bankEasyPay.bankName,
                    maskedAccountNumber: bankEasyPay.maskedAccountNumber,
                    nickName: bankEasyPay.nickName,
                    payPartnershipItemCode: bankEasyPay.payPartnershipItemCode,
                    payPartnershipItemName: bankEasyPay.payPartnershipItemName,
                    payServiceMaintenanceSchedule: bankEasyPay.payServiceMaintenanceSchedule,
                    payable: bankEasyPay.payable,
                    pendingPayable: bankEasyPay.pendingPayable,
                    registrationCompletedDateTime: bankEasyPay.registrationCompletedDateTime,
                    openBankingAgreed: true,
                }
            })

            const defaultAccountKey = payMethod.defaultPayment?.accountKey
            const recentRechargeAccount = getSelectedRechargeAccount(payMethod.recentChargedAccountFirstBankEasyPays)

            /** 자동결제 결제수단으로 선택된 accountKey가 없으면 충전계좌 목록의 첫번째 계좌를 선택된 상태로 초기화 */
            const selectedAccountKey = defaultAccountKey ?? recentRechargeAccount?.accountKey
            state.recharge.selectedAccountKey = selectedAccountKey ?? ''
        })
    },
})

export default slice.reducer
